import { Popover, List, ListItemButton, Checkbox, Button, Grid } from '@mui/material'

const ReportColumnSelector = ({
    open,
    anchorEl,
    onClose,
    columnas, // The full list of columns with 'checked' status
    setColumnas, // The function to update the entire list of columns
    typeReportsSelected,
    embedded = false
}) => {
    const idPopover = open ? 'columns-popover' : undefined

    const handleToggle = (columnId) => {
        const columnIndex = columnas.findIndex(c => c.id === columnId)
        if (columnIndex === -1) return
        const column = columnas[columnIndex]

        if (column.value === 'idIndex') {
            return
        }

        const currentlyCheckedCount = columnas.filter(c => c.checked).length

        // If trying to uncheck
        if (column.checked) {
            if (currentlyCheckedCount <= 3) {
                return
            }
        }

        const newColumnas = [...columnas]
        newColumnas[columnIndex].checked = !newColumnas[columnIndex].checked
        setColumnas(newColumnas)
    }

    const handleBorrarTodo = () => {
        // Reset to default minimal set (OT, PM, SAP ID)
        const defaultSet = ['idIndex', 'idPm', 'sapId']
        const clearedColumnas = columnas.map(c => ({
            ...c,
            checked: defaultSet.includes(c.value)
        }))
        setColumnas(clearedColumnas)
        if (onClose) onClose()
    }

    const handleSelectAll = () => {
        const allSelected = columnas.map(c => {
            // Only check if it's allowed for the current view
            if (!c.restrict || c.restrict.includes(typeReportsSelected)) {
                return { ...c, checked: true }
            }
            return c
        })
        setColumnas(allSelected)
        if (onClose) onClose()
    }

    const columnasFiltradas = columnas.filter(c => {
        if (typeReportsSelected && typeReportsSelected !== 'all' && typeReportsSelected !== 'Todos' && c.restrict && !c.restrict.includes(typeReportsSelected)) {
            return false
        }
        return true
    })

    const content = (
        <div style={{ width: embedded ? '100%' : 300, height: 'auto', padding: 10 }}>
            <div style={{ maxHeight: embedded ? 'none' : 390, overflowY: embedded ? 'visible' : 'auto' }}>
                {embedded
                    ? (
                        <Grid container>
                            {columnasFiltradas.map((columna, i) => {
                                const currentlyCheckedCount = columnas.filter(c => c.checked).length
                                const isFixed = columna.value === 'idIndex'
                                const isLastRemaining = columna.checked && currentlyCheckedCount <= 3
                                const shouldDisable = isFixed || isLastRemaining

                                return (
                                    <Grid item xs={6} md={4} lg={3} key={columna.id || i}>
                                        <ListItemButton
                                            disabled={shouldDisable}
                                            style={{ fontSize: 12, opacity: shouldDisable ? 0.5 : 1 }}
                                            onClick={() => handleToggle(columna.id)}
                                        >
                                            <Checkbox size="small" checked={columna.checked || false} /> {columna.name}
                                        </ListItemButton>
                                    </Grid>
                                )
                            })}
                        </Grid>
                    )
                    : (
                        <List>
                            {columnasFiltradas.map((columna, i) => {
                                const currentlyCheckedCount = columnas.filter(c => c.checked).length
                                const isFixed = columna.value === 'idIndex'
                                const isLastRemaining = columna.checked && currentlyCheckedCount <= 3
                                const shouldDisable = isFixed || isLastRemaining

                                return (
                                    <ListItemButton
                                        key={columna.id || i}
                                        disabled={shouldDisable}
                                        style={{ fontSize: 12, opacity: shouldDisable ? 0.5 : 1 }}
                                        onClick={() => handleToggle(columna.id)}
                                    >
                                        <Checkbox checked={columna.checked || false} /> {columna.name}
                                    </ListItemButton>
                                )
                            })}
                        </List>
                    )}
            </div>
            <div style={{ width: '100%', padding: 10, display: 'flex', gap: 10, justifyContent: 'flex-end' }}>
                {!embedded && (
                    <Button variant={'contained'} style={{ marginBottom: 10 }} fullWidth onClick={onClose}>
                        Confirmar
                    </Button>
                )}
                <Button variant={'outlined'} size="small" style={{ marginBottom: embedded ? 0 : 10 }} fullWidth={!embedded} onClick={handleSelectAll}>
                    Seleccionar Todo
                </Button>
                <Button variant={'contained'} size="small" color="error" fullWidth={!embedded} onClick={handleBorrarTodo}>
                    Borrar Todo
                </Button>
            </div>
        </div>
    )

    if (embedded) {
        return content
    }

    return (
        <Popover
            id={idPopover}
            open={open}
            anchorEl={anchorEl}
            onClose={onClose}
            anchorOrigin={{
                vertical: 'bottom',
                horizontal: 'left'
            }}
        >
            {content}
        </Popover>
    )
}

export default ReportColumnSelector
